import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "a6afe02ec64994ed182f3a78a3ba0617Tz0xMzI4OTcsRT0xODIwNzA3MTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI="
);
